// Lib
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';

// Selectors
import { getMilanoteApplicationModeSelector } from '../platform/platformSelector';

// Components
import MobileWorkspace from '../mobile/MobileWorkspace';
import DesktopWorkspace from './DesktopWorkspace';

// Types
import { MilanoteApplicationMode } from '../../common/platform/platformTypes';
import { GeneralWorkspaceProps } from './workspaceTypes';

const WorkspaceSwitch = (props: GeneralWorkspaceProps): ReactElement => {
    const milanoteAppMode = useSelector(getMilanoteApplicationModeSelector);

    switch (milanoteAppMode) {
        case MilanoteApplicationMode.mobile:
            return <MobileWorkspace {...props} />;
        case MilanoteApplicationMode.desktop:
        default:
            return <DesktopWorkspace {...props} />;
    }
};

export default WorkspaceSwitch;
